module.exports = __webpack_public_path__ + "img/Katarina_acc_02.6dbbbcb8.jpg";